import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { Plus } from "lucide-react";
import { settingsLabels } from "../labels";
import { useLanguage } from "../../../contexts/LanguageContext";

interface NewInsuranceProviderModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  newProviderName: string;
  setNewProviderName: (val: string) => void;
  onAdd: () => void;
  loading?: boolean;
}

export function NewInsuranceProviderModal({
  isOpen,
  onOpenChange,
  newProviderName,
  setNewProviderName,
  onAdd,
  loading
}: NewInsuranceProviderModalProps) {
  const { lang } = useLanguage();
  const t = settingsLabels[lang].insuranceProviders;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onAdd();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-[2.5rem] border-none p-0 overflow-hidden bg-white shadow-2xl">
        <DialogHeader className="px-8 py-6 border-b border-neutral-50 bg-neutral-50/30">
          <DialogTitle className="text-sm font-bold uppercase tracking-widest text-neutral-800 flex items-center gap-3">
            <div className="w-8 h-8 rounded-xl bg-emerald-100 flex items-center justify-center text-emerald-600">
              <Plus className="h-4 w-4" />
            </div>
            {lang === 'pt' ? 'Novo Convênio' : 'New Provider'}
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          <div className="space-y-2">
            <Label className="text-[10px] font-bold uppercase tracking-widest text-neutral-400 ml-1">
              {lang === 'pt' ? 'Nome do Convênio' : 'Provider Name'}
            </Label>
            <Input 
              autoFocus
              className="h-14 rounded-2xl border-neutral-100 bg-neutral-50/30 focus-visible:ring-emerald-500/20 font-bold text-neutral-800" 
              placeholder={lang === 'pt' ? "Ex: Unimed, Bradesco..." : "Ex: Blue Shield, Aetna..."}
              value={newProviderName}
              onChange={e => setNewProviderName(e.target.value)}
              required
            />
          </div>

          <Button 
            type="submit"
            disabled={loading || !newProviderName.trim()}
            className="w-full h-14 bg-emerald-600 hover:bg-emerald-700 text-white font-bold uppercase tracking-widest rounded-2xl transition-all active:scale-95 mt-4"
          >
            {loading ? (
              <div className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <>
                <Plus className="h-4 w-4 mr-2" />
                {lang === 'pt' ? 'Adicionar Convênio' : 'Add Provider'}
              </>
            )}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
